import React from 'react';
import './SceneIndoorHotspot.scss';
import ARROW_DIR from './arrow-dir.gif';
import ARROW_DIR_2 from './arrow-dir-2.gif';
import ARROW_DIR_3 from './arrow-dir-3.gif';

const living1PNHotspotId = '691c215d9d4e2e854cda4560';
const living2PNHotspotId = '691c2b749d4e2e854cda578f';
const living3PNHotspotId = '691c26969d4e2e854cda4f77';

const SceneIndoorHotspot = ({ scene, onClick }) => {
  if (scene._id === living1PNHotspotId) {
    return (
      <div className="s3t-indoor--hotspot" onClick={onClick}>
        <img
          className="s3t-indoor--hotspot-arrow"
          style={{
            top: '61%',
            left: '65%',
            transform:
              'translate(-50%, -50%) rotateX(128deg) rotate(46deg) translate(10px, 16%)',
          }}
          src={ARROW_DIR}
          alt="arrow-dir"
        />
      </div>
    );
  }

  if (scene._id === living2PNHotspotId) {
    return (
      <div className="s3t-indoor--hotspot" onClick={onClick}>
        <img
          className="s3t-indoor--hotspot-arrow"
          style={{
            top: '36%',
            left: '65%',
            transform: 'rotateX(128deg) rotate(69deg) translate(10px, 104%)',
          }}
          src={ARROW_DIR_2}
          alt="arrow-dir-2"
        />
      </div>
    );
  }

  if (scene._id === living3PNHotspotId) {
    return (
      <div className="s3t-indoor--hotspot" onClick={onClick}>
        <img
          className="s3t-indoor--hotspot-arrow"
          style={{
            top: '36%',
            left: '65%',
            transform:
              'rotateX(116deg) rotate(95deg) translate(64%, 4%) scaleY(-1)',
          }}
          src={ARROW_DIR_3}
          alt="arrow-dir-3"
        />
      </div>
    );
  }

  return (
    <div className="khp-indoor-hotspot" onClick={onClick}>
      <div className="khp-indoor-hotspot__pulse">&nbsp;</div>
    </div>
  );
};

export default SceneIndoorHotspot;
